import { ApplicationRef, Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {DOCUMENT} from "@angular/common";
import {CustomAuthService} from "./core-module/services/custom-auth.service";
import {NetworkConnectivityService} from "./core-module/services/network-connectivity.service";
import {AppStateService} from "./core-module/services/app-state.service";
import { filter, Subject, take } from 'rxjs';

import {environment} from "src/environments/environment";
import {LoaderService} from "./core-module/services/loader.service";

@Component({
  standalone: false,
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  count: number = 0;
  unsubscribe = new Subject<void>();

  constructor(
    private authSrv: CustomAuthService,
    public translate: TranslateService,
    private route: ActivatedRoute,
    public _router: Router,
    @Inject(DOCUMENT) private document: Document,
    private networkConnectivityService: NetworkConnectivityService,
    private loaderService: LoaderService,
    private appRef: ApplicationRef,
    private appState: AppStateService
  ) {
    //translate.setDefaultLang("en");
  }

  title = "MultiOne";
  canShow = true;

  ngOnInit() {
    // Initialize network connectivity monitoring
    // The service will automatically handle showing/hiding the error popup
    this.networkConnectivityService.getOnlineStatus().subscribe();
    // Hide loader after navigation ends for non-home routes
    // Home route will handle its own loader hiding in ngAfterViewInit
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // Don't hide loader for home route, let HomeComponent handle it
      if (!event.url.includes('/home') && event.url !== '/' && event.url !== '') {
        // Wait for app to stabilize before hiding loader
        this.appRef.isStable
          .pipe(
            filter(stable => stable),
            take(1)
          )
          .subscribe(() => {
            requestAnimationFrame(() => {
              this.loaderService.hideLoader();
            });
          });
      }
    });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState == 'visible') {
        this.authSrv.tokenCheck();
        this.appState.removeLastActive();
      } else {
        this.storeLastVisible();
      }
    })
    this.canShow = false;

    this.authSrv.baseUrl = environment.multiOneAPIUrl;
    this.authSrv.configureOauth();
     if (!this._router.url.includes("logout=true") && !this._router.url.includes("redirectToLocal"))
      this.authSrv.checkForAutoLogin();
    this.canShow = true;


    this.route.queryParams.subscribe((params) => {
      const lang = params["lang"];
      if (lang === "nl") {
        this.translate.use("nl");
      }
    });
  }

  storeLastVisible() {
    this.appState.setLastActive(JSON.stringify(Date.now()));
  }
}

